import React, { Component } from 'react'
import { Paragraph, Box, Button } from 'grommet';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from './Header';
/*import Footer from './Footer';*/


class ResultPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {

        }
        this.redirectDispute = this.redirectDispute.bind(this);
    }

    redirectDispute() {
        this.props.history.push('/DisputeOnlineRegistered');
    }

    render() {
        const outcome = 
       
                <Box>
                    <Header />
                    <Box style={{ height: '81px' }}/>
                    <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                        <Box className='contentbox' style={{ height: '300px' }}>
                            <Box direction="column" align='center'>
                                <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Operazione andata a buon fine!</h1>
                                <Paragraph className='textParagraph' style={{ textAlign: 'center' }}>La richiesta è stata effettuata correttamente.</Paragraph>
                            </Box>
                        <Box align='center'>
                            <Button color='transparent' className='btnform' label='TORNA A GESTIONE DISPUTE' onClick={this.redirectDispute} />
                        </Box>
                    </Box>
                        
                    </Box>
                </Box>



        return (
            <Box>
                {outcome}
            </Box>
        )
    }
}

export default withRouter(ResultPage)